import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/empty_img.svg'


const _withScopeId = n => (_pushScopeId("data-v-572ca8ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "rotationChart_empty"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "rotationChart_carousel" }
const _hoisted_6 = {
  key: 0,
  class: "rotationChart_carousel_indicator"
}
const _hoisted_7 = ["onClick"]

import { ElCarousel, ElCarouselItem } from 'element-plus';
import { ref, withDefaults } from 'vue';

interface Props {
  component: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RotationChart',
  props: {
    component: { default: Object }
  },
  setup(__props: any) {

const props = __props as { component: any };



// 获取幻灯片index
const indicator = ref(0);
const getIndicator = (e: any) => {
  indicator.value = e;
};
// 手动切换幻灯片
const setActiveItem: any = ref(null);
const setActive = (index: number) => {
  setActiveItem.value.setActiveItem(String(index));
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_unref(ElCarousel), {
    class: _normalizeClass(props.component.rotationChart?.type == 1 ? 'carousel_card' : ''),
    height: "200px",
    autoplay: true,
    interval: props.component.rotationChart?.interval,
    "indicator-position": "none",
    onChange: getIndicator,
    ref_key: "setActiveItem",
    ref: setActiveItem
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.rotationChartList, (item, index) => {
        return (_openBlock(), _createBlock(_unref(ElCarouselItem), {
          key: index,
          class: "rotationChart"
        }, {
          default: _withCtx(() => [
            (item.img)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "rotationChart_img",
                  src: item.img ? item.img : ''
                }, null, 8, _hoisted_1))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)),
            _createElementVNode("div", _hoisted_5, [
              (item.jump.content)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "rotationChart_carousel_title",
                    style: _normalizeStyle({ color: item.jump.titleColor })
                  }, _toDisplayString(item.jump.title), 5))
                : _createCommentVNode("", true),
              (item.jump.content)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "rotationChart_carousel_subtitle",
                    style: _normalizeStyle({ color: item.jump.subtitleColor })
                  }, _toDisplayString(item.jump.subtitle), 5))
                : _createCommentVNode("", true),
              (item.jump.content)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "rotationChart_carousel_profiles",
                    style: _normalizeStyle({ color: item.jump.profilesColor })
                  }, _toDisplayString(item.jump.profiles), 5))
                : _createCommentVNode("", true),
              (item.jump.btn)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 3,
                    class: "rotationChart_carousel_btn",
                    type: "primary",
                    size: "small",
                    style: _normalizeStyle({ background: item.jump.btnColor, color: item.jump.btnNameColor })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.jump.btnName), 1)
                    ]),
                    _: 2
                  }, 1032, ["style"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      (props.component.rotationChart?.type !== 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.rotationChartList?.length, (ditem, dindex) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
          indicator.value == dindex ? 'indicator_dot_click' : '',
          props.component.rotationChart?.indicatorType == 0 ? 'indicator_dot' : 'indicator_dot indicator_dot_1',
        ]),
                key: ditem,
                onClick: ($event: any) => (setActive(dindex))
              }, null, 10, _hoisted_7)), [
                [_vShow, props.component.rotationChart?.indicatorType !== 2]
              ])
            }), 128)),
            _withDirectives(_createElementVNode("div", { class: "indicator_dot_2" }, _toDisplayString(indicator.value + 1) + "/" + _toDisplayString(props.component.rotationChartList?.length), 513), [
              [_vShow, props.component.rotationChart?.indicatorType == 2]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "interval"]))
}
}

})